export default {
  tabs: [],
  currentTab: null,
  currentTabId: null,
  untitledLastIndex: 0,
  predefinedInquiries: [],
  db: null
}
